export default 'M17 7.5 22 0H2v22a2 2 0 0 0 4 0v-7h16z';